import { render, staticRenderFns } from "./SectionWrapper.vue?vue&type=template&id=b94a1e46&scoped=true"
import script from "./SectionWrapper.vue?vue&type=script&lang=js"
export * from "./SectionWrapper.vue?vue&type=script&lang=js"
import style0 from "./SectionWrapper.vue?vue&type=style&index=0&id=b94a1e46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b94a1e46",
  null
  
)

export default component.exports